import { FC, PropsWithChildren } from 'react';

import { Text } from '@hh.ru/magritte-ui';

import { getTextStyle } from 'src/components/ResumeCard/utils/getTextStyle';

import styles from './index.less';

const Content: FC<{ isVisited: boolean } & PropsWithChildren> = ({ isVisited, children }) => {
    return (
        <div className={styles.resumeCardContent}>
            <Text typography="label-3-regular" style={getTextStyle(isVisited)}>
                {children}
            </Text>
        </div>
    );
};

export default Content;
